import { INVALID_STATUSES, PRIORITY_STATUSES, VALID_STATUSES } from 'constants/quoteStatus';
import { RequestStatus, QuoteStatus, Quote, Statuses } from 'types/quote';

export const getStatus = (status: RequestStatus, statuses: Statuses): QuoteStatus => {
  for (const [key, value] of Object.entries(statuses)) {
    if (value.values.includes(status)) {
      return key as QuoteStatus;
    }
  }
  return 'init';
};

export const getStatusColor = (status: QuoteStatus) => {
  switch (status) {
    case 'applicationCompleted':
    case 'accepted':
    case 'rentCompleted':
    case 'rentCanceled':
      return 'info';
    case 'rented':
      return 'success';
    case 'expired':
    case 'invalid':
    case 'declined':
    case 'canceled':
      return 'error';
    case 'suspended':
      return 'warning';
    default:
      return 'primary';
  }
};

export const getRoomStatus = (quotes: Quote[]) => {
  if (quotes.some((quote) => VALID_STATUSES.includes(quote.status))) {
    for (const status of PRIORITY_STATUSES) {
      const found = quotes.find((quote) => quote.status === status);
      if (found) return status;
    }
  }

  if (quotes.some((quote) => quote.status === 'suspended')) {
    return 'suspended';
  }
  if (quotes.every((quote) => INVALID_STATUSES.includes(quote.status))) {
    return 'invalid';
  }
  return 'init';
};

export const sortQuotesByStatus = (quotes: Quote[]) => {
  return quotes.slice().sort((a, b) => {
    const statusA = PRIORITY_STATUSES.indexOf(a.status as QuoteStatus);
    const statusB = PRIORITY_STATUSES.indexOf(b.status as QuoteStatus);

    if (statusA !== statusB) {
      return statusA - statusB;
    }

    const dateA = new Date(a.createdOn).getTime();
    const dateB = new Date(b.createdOn).getTime();
    return dateB - dateA;
  });
};
